import { AppConfig, CapabilityApplications } from '@hcs/types';

import { EXTERNAL_APP_CONFIGS } from './external';
import { INTERNAL_APP_CONFIGS } from './internal';

/** generated by generate-export-buckets */
export * from './external';
export * from './internal';

export const ALL_APP_CONFIGS = [
  ...EXTERNAL_APP_CONFIGS,
  ...INTERNAL_APP_CONFIGS,
];

export const ALL_APP_CONFIGS_BY_KEY = ALL_APP_CONFIGS.reduce<
  Partial<Record<CapabilityApplications, AppConfig>>
>((data, appConfig) => {
  data[appConfig.applicationKey] = appConfig;
  return data;
}, {});
